import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = { class: "bg-dark text-center my-5" }
const _hoisted_3 = { class: "container container-fluid" }
const _hoisted_4 = { class: "card contents shadow-sm mb-5 border-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link active",
      id: "book-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#book",
      type: "button",
      role: "tab",
      "aria-controls": "book",
      "aria-selected": "true"
    }, "Book a Table")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link",
      id: "menu-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#menu-items",
      type: "button",
      role: "tab",
      "aria-controls": "menu-items",
      "aria-selected": "false"
    }, "Menu")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link",
      id: "details-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#details",
      type: "button",
      role: "tab",
      "aria-controls": "details",
      "aria-selected": "false"
    }, "Details")
  ])
], -1)
const _hoisted_6 = { class: "tab-content p-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade show active",
  id: "book",
  role: "tabpanel",
  "aria-labelledby": "book-tab"
}, "Booking", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "menu-items",
  role: "tabpanel",
  "aria-labelledby": "menu-tab"
}, "Menu", -1)
const _hoisted_9 = {
  class: "tab-pane fade",
  id: "details",
  role: "tabpanel",
  "aria-labelledby": "details-tab"
}
const _hoisted_10 = { class: "d-flex mb-4" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, "Dine-in hours", -1)
const _hoisted_16 = { class: "p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_page_loader = _resolveComponent("page-loader")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    (_ctx.restaurant_details)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", {
              class: "py-5 image-header restaurant-details-header",
              style: _normalizeStyle('background-image: url(' + _ctx.restaurant_details.featured_photo_thumbnails.full + ')')
            }, null, 4)
          ]),
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: _ctx.restaurant_details.logo_thumbnails.square_thumbnail,
                        class: "me-2"
                      }, null, 8, _hoisted_11),
                      _createElementVNode("span", null, [
                        _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.restaurant_details.name), 1),
                        _createElementVNode("p", _hoisted_13, [
                          (_ctx.restaurant_details.cuisines && _ctx.restaurant_details.cuisines.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.restaurant_details.cuisines[0].name), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_14
                              ], 64))
                        ])
                      ])
                    ]),
                    _hoisted_15,
                    _createElementVNode("ul", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dine_in_hours, (date_item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: date_item.date,
                          class: "d-flex mb-2"
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-uppercase fw-bold date-item", date_item.isToday ? 'text-primary' : 'text-muted'])
                          }, _toDisplayString(date_item.date), 3),
                          _createElementVNode("span", {
                            class: _normalizeClass(date_item.isToday ? 'text-primary' : 'text-secondary')
                          }, _toDisplayString(date_item.hours), 3)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createBlock(_component_page_loader, { key: 1 })),
    _createVNode(_component_Footer)
  ]))
}